import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { Button, Stack, Text, Card, Textarea } from "@chakra-ui/react";
import { t } from "i18next";
import { ManageScopes } from "../../../account/views/integrations/ManagePermissionsModal/ManageScopes";
import { ApiClient } from "../../../account/models/ApiClient";
import { useStores } from "../../../shared/stores/RootStore";
import { CustomDialog } from "../../../shared/views/CustomDialog";
import { toast } from "../../../shared/views/CustomToaster";

const i18prefix = "account:Integrations";

export interface ManagePermissionsModalProps {
  apiClient: ApiClient;
  onClose: () => void;
}

const ManagePermissionsModalBase: React.FC<ManagePermissionsModalProps> = ({
  onClose,
  apiClient,
}) => {
  const { accountStore } = useStores();
  const [scopes, setScopes] = useState(new Set(apiClient.scopes));
  const [permissions, setPermissions] = useState(apiClient.permissions);

  const onSubmit = () => {
    accountStore
      .updateApiClient(apiClient.id, {
        name: apiClient.name,
        permissions: permissions,
        scopes: [...scopes],
      })
      .then(() => {
        toast("success", t(`${i18prefix}.toast.saveSuccess`));
      })
      .catch(() => {
        toast("error", t(`${i18prefix}.toast.saveFailed`));
      });
  };

  return (
    <CustomDialog
      onClose={onClose}
      size="lg"
      header={t(`${i18prefix}.permissionsModal.title`)}
      footer={
        <Button flexShrink={0} colorPalette="primary" onClick={onSubmit}>
          {t(`${i18prefix}.permissionsModal.submit`)}
        </Button>
      }
    >
      <Stack gap={4} fontSize="sm">
        <ManageScopes scopes={scopes} setScopes={setScopes} />

        <Card.Root variant="outline" p={3}>
          <Stack>
            <Text fontSize="xs" fontWeight="semibold" textTransform="uppercase">
              {t(`${i18prefix}.permissions.title`)}
            </Text>

            <Textarea
              placeholder="*/*,Route/*,Survey/a30feaa1-4be1-4d6a-a168-f8686a55895f"
              fontFamily="monospace"
              value={permissions}
              onChange={(e) => setPermissions(e.target.value)}
            />
          </Stack>
        </Card.Root>
      </Stack>
    </CustomDialog>
  );
};

export const ManagePermissionsModal = observer(ManagePermissionsModalBase);
